import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [acfData, setAcfData] = useState(null);
  const [fondoUrl, setFondoUrl] = useState('');

  const postsPerPage = 4;

  const fetchPosts = async () => {
    try {
      const response = await fetch('https://interprika.com/cms/wp-json/wp/v2/posts?_embed');
      const data = await response.json();
      setPosts(data);
      setTotalPages(Math.ceil(data.length / postsPerPage));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://interprika.com/cms/wp-json/wp/v2/pages/183');
        const data = await response.json();

        setAcfData(data.acf);

        if (data.acf?.fondo) {
          const imageResponse = await fetch(
            `https://interprika.com/cms/wp-json/wp/v2/media/${data.acf.fondo}`
          );
          const imageData = await imageResponse.json();
          setFondoUrl(imageData.source_url);
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const recentPosts = posts.slice(0, 4);

  const getFeaturedImage = (post) => {
    const embedded = post?._embedded;
    const media = embedded?.['wp:featuredmedia']?.[0];
    return media?.source_url || '';
  };

  if (loading) {
    return (
      <div className="w-full h-full bg-black fixed top-0 z-[999999999] flex flex-col justify-center items-center">
        <img className="w-[300px] max-md:w-[150px] h-[44px] object-contain" src="./images/logo.png" alt="" />
      </div>
    );
  }

  return (
    <div className="pb-10">
      {/* ✅ SOLO CSS: estilos para interpretar el contenido del editor WP */}
      <style>{`
        .wp-content {
          font-size: 16px;
          line-height: 1.75;
        }

        .wp-content p { margin: 0 0 1rem; }
        .wp-content strong { font-weight: 700; }
        .wp-content em { font-style: italic; }
        .wp-content del { text-decoration: line-through; }

        .wp-content h1 {
          font-size: 2rem;
          line-height: 2.2rem;
          font-weight: 700;
          margin: 1.5rem 0 1rem;
        }
        .wp-content h2 {
          font-size: 1.5rem;
          line-height: 1.9rem;
          font-weight: 700;
          margin: 1.25rem 0 0.75rem;
        }
        .wp-content h3 {
          font-size: 1.25rem;
          font-weight: 700;
          margin: 1rem 0 0.5rem;
        }

        /* ✅ LISTAS (ul/ol/li + anidadas) */
        .wp-content ul,
        .wp-content ol {
          margin: 0 0 1rem;
          padding-left: 1.5rem;
        }
        .wp-content ul { list-style: disc; }
        .wp-content ol { list-style: decimal; }

        .wp-content li { margin: 0.25rem 0; }

        .wp-content li > ul,
        .wp-content li > ol {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          padding-left: 1.25rem;
        }

        .wp-content ul ul { list-style: circle; }
        .wp-content ul ul ul { list-style: square; }

        /* Task lists (si algún plugin las mete) */
        .wp-content ul.task-list {
          list-style: none;
          padding-left: 0;
        }
        .wp-content ul.task-list li {
          display: flex;
          gap: 0.5rem;
          align-items: flex-start;
        }
        .wp-content ul.task-list input[type="checkbox"] {
          margin-top: 0.25rem;
        }

        .wp-content blockquote {
          margin: 1.25rem 0;
          padding: 0.75rem 1rem;
          border-left: 4px solid #F89D38;
          background: rgba(248, 157, 56, 0.08);
        }
        .wp-content blockquote p { margin: 0; }

        .wp-content hr {
          margin: 1.5rem 0;
          border: 0;
          border-top: 1px solid rgba(0,0,0,0.15);
        }

        .wp-content img {
          max-width: 100%;
          height: auto;
          display: block;
        }

        /* Alineaciones típicas de WP */
        .wp-content img.alignleft { float: left; margin: 0.25rem 1rem 1rem 0; }
        .wp-content img.alignright { float: right; margin: 0.25rem 0 1rem 1rem; }
        .wp-content img.aligncenter { margin-left: auto; margin-right: auto; }

        /* Limpia floats para que no rompa layout */
        .wp-content::after {
          content: "";
          display: block;
          clear: both;
        }

        /* Por si luego usas Gutenberg */
        .wp-content .has-text-align-center { text-align: center; }
        .wp-content .has-text-align-right { text-align: right; }
        .wp-content .has-text-align-left { text-align: left; }

        /* FORZAR ESTILOS DE LISTAS WP */
        .wp-content ul {
          list-style-type: disc !important;
          list-style-position: outside;
          padding-left: 1.5rem;
        }

        .wp-content ol {
          list-style-type: decimal !important;
          list-style-position: outside;
          padding-left: 1.5rem;
        }

        .wp-content li {
          display: list-item !important;
          margin: 0.25rem 0;
        }

        /* Listas anidadas */
        .wp-content ul ul {
          list-style-type: circle !important;
        }

        .wp-content ul ul ul {
          list-style-type: square !important;
        }

        .wp-content ol ol {
          list-style-type: lower-alpha !important;
        }

      `}</style>

      <div className="bg-[#000] overflow-hidden relative">
        {fondoUrl && (
          <img className="w-full max-md:h-[300px] object-contain" src={fondoUrl} alt="Header Background" />
        )}
        <div className="flex flex-col justify-center items-center w-full h-full top-[-50px] absolute">
          <motion.div
            className="text-white [&_p]:text-[22px] [&_p]:md:text-[48px] [&_p]:leading-[28px] [&_p]:md:leading-[48px] pb-2"
            dangerouslySetInnerHTML={{ __html: acfData?.titulo }}
            initial="hidden"
            whileInView="visible"
            variants={{ hidden: { opacity: 0, y: -200 }, visible: { opacity: 1, y: 0 } }}
            transition={{ duration: 0.5 }}
          />
          <motion.h4
            className="text-white"
            initial="hidden"
            whileInView="visible"
            variants={{ hidden: { opacity: 0, x: -200 }, visible: { opacity: 1, x: 0 } }}
            transition={{ duration: 0.5 }}
            dangerouslySetInnerHTML={{ __html: acfData?.subtitulo }}
          />
        </div>
        <div className="mt-[-100px]">
          <div className="clip-diagonal-white"></div>
        </div>
      </div>

      <div className="w-[1280px] 2xl:w-[1440px] pt-[30px] max-w-full px-[30px] lg:px-[100px] mx-auto">
        <div className="flex flex-col lg:flex-row relative items-center">
          <div className="w-full lg:w-3/4 py-5 pr-5">
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={{ hidden: { opacity: 0, y: -200 }, visible: { opacity: 1, y: 0 } }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="text-lg md:text-[32px] leading-[24px] md:leading-[32px] font-medium pt-10 mb-2">
                <span className="font-bold">BLOG</span>
              </h2>
            </motion.div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row relative">
          <div className="w-full lg:w-3/4 pb-5 border-r">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {currentPosts.map((post) => {
                const featured = getFeaturedImage(post);

                return (
                  <motion.div
                    key={post.id}
                    className="bg-white pr-7 pt-4"
                    initial="hidden"
                    whileInView="visible"
                    variants={{ hidden: { opacity: 0, x: -200 }, visible: { opacity: 1, x: 0 } }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    {featured ? (
                      <img
                        src={featured}
                        alt={post.title?.rendered || 'Imagen destacada'}
                        className="w-full h-[200px] object-cover rounded-md mb-4"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-[200px] bg-gray-300 rounded-md mb-4"></div>
                    )}

                    <h2 className="text-lg font-bold mb-2">{post.title.rendered}</h2>

                    <div className="text-[#F89D38] text-sm mb-2 flex justify-between">
                      <span>{Math.ceil(post.content.rendered.split(' ').length / 200)} min de lectura</span>
                      <span>{new Date(post.date).toLocaleDateString()}</span>
                    </div>

                    {/* excerpt sigue igual */}
                    <p
                      className="text-sm text-gray-600 mb-4 line-clamp-2"
                      dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
                    />

                    <Link to={`/blog/${post.id}`} className="text-[#F89D38] text-sm font-semibold flex items-center gap-2">
                      Leer más <img src="/images/icons/arrow-right-orange.svg" alt="Leer más" className="h-4 w-4" />
                    </Link>
                  </motion.div>
                );
              })}
            </div>

            <div className="flex justify-between mt-8 pr-7">
              <button
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-[#000000] hover:bg-[#000000cc] disabled:hover:bg-[#000] disabled:opacity-40 text-white"
              >
                Anterior
              </button>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-[#000000] hover:bg-[#000000cc] disabled:hover:bg-[#000] disabled:opacity-40 text-white"
              >
                Siguiente
              </button>
            </div>
          </div>

          <div className="w-full lg:w-1/4 pt-4 md:p-4 sticky md:top-[140px] h-[400px]">
            <h3 className="md:mt-[-80px] mb-12 text-right bg-black text-white border border-black transition-all duration-500 hover:bg-white hover:text-black p-1 px-3">
              Últimos <span className="font-bold">Artículos</span>
            </h3>

            {recentPosts.map((post) => {
              const featured = getFeaturedImage(post);

              return (
                <motion.div
                  key={post.id}
                  className="mb-4"
                  initial="hidden"
                  whileInView="visible"
                  variants={{ hidden: { opacity: 0, y: -200 }, visible: { opacity: 1, y: 0 } }}
                  transition={{ duration: 0.5 }}
                >
                  <Link to={`/blog/${post.id}`} className="flex items-center">
                    {featured ? (
                      <img
                        src={featured}
                        alt={post.title?.rendered || 'Imagen destacada'}
                        className="flex-shrink-0 w-[60px] h-[60px] object-cover rounded"
                        loading="lazy"
                      />
                    ) : (
                      <div className="flex-shrink-0 w-[60px] h-[60px] bg-gray-300 rounded"></div>
                    )}

                    <div className="ml-4">
                      <h4 className="text-sm font-medium uppercase">{post.title.rendered}</h4>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;